import { firebaseDb } from '../../config/firebaseConfig'

function getMenu(agencyId, experienceId) {
  return firebaseDb
    .collection(`agency/${agencyId}/experiences/${experienceId}/menu`)
    .get()
    .then((querySnapshot) => {
      let data = {}
      querySnapshot.forEach((doc) => (data = { ...doc.data() }))
      return data
    })
}

function getCategoryProducts(agencyId, experienceId, menuId) {
  return firebaseDb
    .collection(
      `agency/${agencyId}/experiences/${experienceId}/menu/${menuId}/categoryProducts`,
    )
    .get()
    .then((querySnapshot) => {
      let data = []
      querySnapshot.forEach((doc) => {
        data.push(doc.data())
      })
      return data
    })
}

function getProductsByCategory(agencyId, experienceId, menuId, categoryId) {
  return firebaseDb
    .collection(
      `agency/${agencyId}/experiences/${experienceId}/menu/${menuId}/products`,
    )
    .where('category.key', '==', categoryId)
    .get()
    .then((querySnapshot) => {
      let data = []
      querySnapshot.forEach((doc) => {
        data.push(doc.data())
      })
      return data
    })
}

function getProducts(agencyId, experienceId, menuId) {
  return firebaseDb.collection(
    `agency/${agencyId}/experiences/${experienceId}/menu/${menuId}/products`,
  )
}

function getGroups(agencyId, experienceId, menuId, productId) {
  return firebaseDb.collection(
    `agency/${agencyId}/experiences/${experienceId}/menu/${menuId}/products/${productId}/groups`,
  )
  /*  .get()
    .then((querySnapshot) => {
      let data = []
      querySnapshot.forEach((doc) => {
        data.push(doc.data())
      })
      return data
    }) */
}

function getGroupOptions(agencyId, experienceId, menuId, productId, groupId) {
  return firebaseDb
    .collection(
      `agency/${agencyId}/experiences/${experienceId}/menu/${menuId}/products/${productId}/groups/${groupId}/options`,
    )
    .get()
    .then((querySnapshot) => {
      let data = []
      querySnapshot.forEach((doc) => {
        data.push(doc.data())
      })
      return data
    })
}

//Funcion utilizada para agregar opciones a los grupos
function addGroup(agencyId, experienceId, menuId) {
  const productId = 'BFu357bUXqxxIdxL7yfU'
  const groupId = 'TaG86U4SlHXCzQXQ48XU'
  const options = [
    {
      isExtra: false,
      isRequired: false,
      name: 'Queso',
      price: 1000,
    },
    {
      isExtra: false,
      isRequired: false,
      name: 'Salsa',
      price: 1000,
    },
    {
      isExtra: false,
      isRequired: false,
      name: 'Pepperoni',
      price: 1200,
    },
  ]

  return firebaseDb
    .collection(
      `agency/${agencyId}/experiences/${experienceId}/menu/${menuId}/products/${productId}/groups`,
    )
    .doc(groupId)
    .update({ options })
    .then(() => console.log('updated'))
    .catch((err) => console.log(err))
}

export {
  getMenu,
  getCategoryProducts,
  getProductsByCategory,
  getGroups,
  getGroupOptions,
  addGroup,
  getProducts,
}
